/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationModalTaskInfo_task = {
    readonly id: string;
    readonly name: string | null;
    readonly estimateForecastMinutes: number | null;
    readonly totalMinutesRegistered: number | null;
    readonly project: {
        readonly estimationUnit: string | null;
        readonly minutesPerEstimationPoint: number | null;
    } | null;
    readonly " $refType": "TimeRegistrationModalTaskInfo_task";
};
export type TimeRegistrationModalTaskInfo_task$data = TimeRegistrationModalTaskInfo_task;
export type TimeRegistrationModalTaskInfo_task$key = {
    readonly " $data"?: TimeRegistrationModalTaskInfo_task$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TimeRegistrationModalTaskInfo_task">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeRegistrationModalTaskInfo_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimateForecastMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalMinutesRegistered",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimationUnit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minutesPerEstimationPoint",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task"
};
(node as any).hash = 'af5e4bb4a54460d5876e39c566fdc048';
export default node;
